import { useTranslation } from 'react-i18next';

import type ILaunchpadLaneProps from './interfaces/ILaunchpadLaneProps';

import styles from './sass/LaunchpadLane.module.scss';

function LaunchpadLane({ lane, children }: ILaunchpadLaneProps) {
  const { t } = useTranslation();

  return (
    <section
      className={styles.root}
      data-lane-id={lane.id}
      aria-label={t(lane.titleI18nKey)}
    >
      <h2 className={styles.title}>{t(lane.titleI18nKey)}</h2>
      <div className={styles.cards}>
        {children}
      </div>
    </section>
  );
}

export default LaunchpadLane;
